import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .trim()
    .required("Password is required")
    .matches(/^(?=.*\d).{8,}$/, {
      message:
        "Password must be at least 8 characters and contain at least 1 number",
    }),
  confirmPassword: Yup.string()
    .trim()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password"), null], "Passwords do not match"),
});
